<div class="home-container" style="background-color: #f8f9fa;">


  <div class="error-container" *ngIf="error">
    <div class="error-icon">!</div>
    <p>{{error.message}}</p>
    <button class="retry-button" (click)="retryLoad()">Retry</button>
  </div>
  <div class="div" style="width: 100%; padding: 10px;">
    <div class="banner-wrapper">
      <div class="content" *ngIf="!error">
        <div class="main-banner-section">
          <!-- Banner Principal -->
          <section class="main-banner">
            <!-- Placeholder persistente con fade (sin ngIf para evitar reflow) -->
            <div class="banner-placeholder" [class.visible]="isLoadingBanner || !isBannerImageLoaded"
              [ngStyle]="featuredArticle?.imagePreview ? {'background-image': 'url(' + (featuredArticle?.imagePreview || '') + ')', 'background-size': 'cover', 'background-position': 'center', 'filter': 'blur(10px)'} : {'background-color':'#000'}">
              <div class="placeholder-content">
                <div class="banner-loading" *ngIf="!isBannerImageLoaded">
                  <img src="../../../assets/images/borde-general.png" alt="Borde logo" class="loading-logo" />
                  <span>Cargando...</span>
                </div>
              </div>
            </div>

            <!-- Banner real -->
            <div class="banner-content" *ngIf="!isLoadingBanner && featuredArticle">
              <div class="main-news" [routerLink]="['/noticias', featuredArticle.slug]" style="cursor: pointer;">
                <!-- Imagen con manejo de carga mejorado -->
       <img *ngIf="bannerSrc" 
         [src]="bannerSrc"
                     [alt]="featuredArticle.title" 
                     loading="eager" 
                     fetchpriority="high" 
                     decoding="async" 
                     importance="high"
                     width="100%" 
                     height="100%" 
                     class="banner-image"
                     (load)="isBannerImageLoaded = true"
                     (error)="isBannerImageLoaded = true">
                <div class="main-news-content">
                  <span class="category">{{ featuredArticle.subcategory || featuredArticle.category }}</span>
                  <h1>{{featuredArticle.title}}</h1>
                  <p class="summary">{{featuredArticle.excerpt}}</p>
                </div>
              </div>
            </div>
          </section>

          <!-- Noticias destacadas -->
          <section class="news-section featured-news" *ngIf="featuredArticles.length > 0">
            <h2 class="section-title">NOTICIAS DESTACADAS</h2>
            <div class="news-grid" style="background-color: black;">
              <app-news-grid [articles]="featuredArticles" [columns]="3"></app-news-grid>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>

  <!-- Contenido secundario que se cargará después -->
  <ng-container *ngIf="!isLoadingBanner">
    <!-- Actualidad Section with Sidebar -->
    <section id="latest-news" class="news-section city-news">
      <div class="main-content">
        <h2 class="section-title" style="margin-bottom: -10px !important;">ACTUALIDAD</h2>
        <app-news-grid [articles]="cityNews.slice(0,3)" [columns]="3"></app-news-grid>

        <!-- Opinion Banner -->
        <div class="opinion-banner">
          <div class="opinion-content" [routerLink]="opinionArticle ? ['/noticias', opinionArticle.slug] : []"
            style="cursor: pointer;">
            <div class="opinion-image">
              <img *ngIf="opinionArticle && getImageSrc(opinionArticle)" [src]="getImageSrc(opinionArticle)"
                [alt]="opinionArticle && opinionArticle.title">
              <div class="opinion-overlay">
                <span class="category">OPINIÓN</span>
                <h3 class="opinion-title">{{opinionArticle && opinionArticle.title}}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <aside class="sidebar">
        <div class="latest-news">
          <h3 class="sidebar-title">ÚLTIMAS NOTICIAS</h3>
          <div class="latest-news-list">
            <ng-container *ngIf="latestArticles.length > 0">
              <div class="latest-news-item" *ngFor="let article of latestArticles | slice:0:8"
                [routerLink]="['/noticias', article.slug]" style="cursor: pointer;">
                <span class="timestamp">{{article.publishDate | date:'shortTime'}}</span>
                <h4>{{article.title}}</h4>
              </div>
            </ng-container>
          </div>
        </div>
      </aside>
    </section>

    <!-- POLÍTICA Section -->
    <div class="politics-news-wrapper">
      <section id="politics" class="news-section politics-news">
        <h2 class="section-title">POLÍTICA</h2>
        
        <!-- Loading placeholder -->
        <div *ngIf="!sectionsLoaded.politics" class="section-loading">
          <div class="loading-skeleton">
            <div class="skeleton-item" *ngFor="let item of [1,2,3]">
              <div class="skeleton-image"></div>
              <div class="skeleton-content">
                <div class="skeleton-line"></div>
                <div class="skeleton-line short"></div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Content -->
        <div class="politics-grid" *ngIf="sectionsLoaded.politics">
          <div class="politics-card" *ngFor="let article of politicsNews | slice:0:3"
            [routerLink]="['/noticias', article.slug]">
            <div class="politics-card__image">
              <img *ngIf="getImageSrc(article)" [src]="getImageSrc(article)" [alt]="article.title">
            </div>
            <div class="politics-card__content">
              <span class="politics-card__category">{{ article.subcategory || article.category }}</span>
              <h3 class="politics-card__title">{{article.title}}</h3>
              <span class="politics-card__time">{{article.publishDate | date:'dd/MM/yyyy | HH:mm' | uppercase }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Weather Forecast -->
    <section id="weather" class="weather-forecast">
      <div class="container">
        <div class="weather-content">
          <ng-container *ngIf="!isLoadingWeather && sectionsLoaded.weather; else loadingWeather">
            <div class="weather-info" *ngIf="weatherInfo">
              <div class="current-weather">
                <div class="current-temp">
                  <img *ngIf="weatherInfo?.current?.icon"
                    [src]="'https://openweathermap.org/img/w/' + weatherInfo.current.icon + '.png'"
                    [alt]="weatherInfo.current.description">
                  <span class="temp">{{weatherInfo.current.temp}}°</span>
                </div>
                <div class="weather-details">
                  <h4>Capital Federal</h4>
                  <p class="description">{{weatherInfo.current.description}}</p>
                </div>
              </div>

              <!-- Weekly Forecast -->
              <div class="weekly-forecast">
                <div class="forecast-day" *ngFor="let day of weatherInfo.forecast">
                  <span class="day">{{getDayName(day.date)}}</span>
                  <img [src]="'https://openweathermap.org/img/w/' + day.icon + '.png'" [alt]="day.description">
                  <span class="temp">{{day.temp}}°</span>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #loadingWeather>
            <div class="weather-loading">
              <i class="bi bi-thermometer-half"></i>
              <span>Cargando información del clima...</span>
            </div>
          </ng-template>
        </div>
      </div>
    </section>

    <!-- Historias Section -->
    <section id="stories" class="news-section stories-news">
      <!-- Loading placeholder -->
      <div *ngIf="!sectionsLoaded.stories" class="section-loading">
        <div class="stories-skeleton">
          <div class="skeleton-story" *ngFor="let item of [1,2,3,4]">
            <div class="skeleton-story-image"></div>
          </div>
        </div>
      </div>
      
      <!-- Content -->
      <div class="stories-scroll" *ngIf="sectionsLoaded.stories">
        <div class="stories-grid">
          <a *ngFor="let article of storiesNews" [routerLink]="['/noticias', article.slug]" class="story-card">
            <div class="story-image">
              <img *ngIf="getImageSrc(article)" [src]="getImageSrc(article)" [alt]="article.title" class="story-img">
              <div class="story-overlay"></div>
              <h3 class="story-title">{{article.title}}</h3>
            </div>
          </a>
        </div>
      </div>
    </section>

    <!-- ECONOMÍA Section -->
    <section id="economy" class="news-section economy-news">
      <h2 class="section-title" style="margin-bottom: -10px !important;">ECONOMÍA</h2>
      
      <!-- Loading placeholder -->
      <div *ngIf="!sectionsLoaded.economy" class="section-loading">
        <div class="loading-skeleton">
          <div class="skeleton-item" *ngFor="let item of [1,2,3]">
            <div class="skeleton-image"></div>
            <div class="skeleton-content">
              <div class="skeleton-line"></div>
              <div class="skeleton-line short"></div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Content -->
      <div class="news-grid" *ngIf="sectionsLoaded.economy">
        <app-news-grid [articles]="economyNews" [columns]="3"></app-news-grid>
      </div>
    </section>

    <!-- DEPORTES Section -->
    <section id="sports" class="news-section sports-news">
      <h2 class="section-title" style="margin-bottom: -10px !important; margin-top: -50px !important;">DEPORTES</h2>
      
      <!-- Loading placeholder -->
      <div *ngIf="!sectionsLoaded.sports" class="section-loading">
        <div class="loading-skeleton">
          <div class="skeleton-item" *ngFor="let item of [1,2,3]">
            <div class="skeleton-image"></div>
            <div class="skeleton-content">
              <div class="skeleton-line"></div>
              <div class="skeleton-line short"></div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Content -->
      <div class="news-grid" *ngIf="sectionsLoaded.sports">
        <app-news-grid [articles]="sportsNews" [columns]="3"></app-news-grid>
      </div>
    </section>

    <!-- Mundo Section -->
    <section id="world" class="news-section world-news">
      <h2 class="section-title" style="margin-bottom: -10px !important; margin-top: -50px !important;">MUNDO</h2>
      
      <!-- Loading placeholder -->
      <div *ngIf="!sectionsLoaded.world" class="section-loading">
        <div class="loading-skeleton">
          <div class="skeleton-item" *ngFor="let item of [1,2,3]">
            <div class="skeleton-image"></div>
            <div class="skeleton-content">
              <div class="skeleton-line"></div>
              <div class="skeleton-line short"></div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Content -->
      <div class="news-grid" *ngIf="sectionsLoaded.world">
        <app-news-grid [articles]="worldNews" [columns]="3"></app-news-grid>
      </div>
    </section>

    <!-- IND.ARG Section -->
    <section id="indarg" class="news-section indarg-news">
      <div class="section-header">
        <h2 class="section-title" style="margin-bottom: -10px !important; margin-top: -50px !important;">IND.ARG</h2>
        <a [routerLink]="['/ind-arg']" class="view-all-link">Ver todas <i class="bi bi-arrow-right"></i></a>
      </div>
      
      <!-- Loading placeholder -->
      <div *ngIf="!sectionsLoaded.indarg" class="section-loading">
        <div class="loading-skeleton">
          <div class="skeleton-item" *ngFor="let item of [1,2,3]">
            <div class="skeleton-image"></div>
            <div class="skeleton-content">
              <div class="skeleton-line"></div>
              <div class="skeleton-line short"></div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Content -->
      <div class="news-grid" *ngIf="sectionsLoaded.indarg">
        <app-news-grid [articles]="indArgNews" [columns]="3"></app-news-grid>
      </div>
    </section>
    
    <section #newsContent class="news-content">
      <div class="container">
      </div>
    </section>
  </ng-container>
</div>